import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { assetService } from "../services/assetService";
import { partnerService, Partner } from "../services/partnerService";
import { Interpreter } from "../services/partnerInterpreterService";

interface LanguageOption {
  language: string;
  name: string;
  flag: string;
}

const InterpreterSelectLanguage: React.FC = () => {
  const navigate = useNavigate();

  const [logo, setLogo] = useState<string | undefined>();
  const [partner, setPartner] = useState<Partner | undefined>();
  const [selectedLang, setSelectedLang] = useState<string | undefined>();

  const interpreterLanguages: LanguageOption[] = [
    { language: "jp", name: "Japanese", flag: assetService.getFlag("jp") },
    { language: "cn", name: "Chinese", flag: assetService.getFlag("cn") },
    { language: "kr", name: "Korean", flag: assetService.getFlag("kr") },
    { language: "fr", name: "French", flag: assetService.getFlag("fr") },
    { language: "ae", name: "Arab", flag: assetService.getFlag("ae") },
    { language: "mn", name: "Myanmar", flag: assetService.getFlag("mn") },
  ];

  useEffect(() => {
    const p = partnerService.getPartner();
    if (!p) {
      navigate("/");
      return;
    }

    setPartner(p);
    setLogo(assetService.getLogo(p.name));

    const lang = (p as Interpreter).interpreterLanguage;
    if (lang) setSelectedLang(lang);
  }, [navigate]);

  const selectLanguage = (language: string) => {
    if (!partner) return;

    (partner as Interpreter).interpreterLanguage = language;
    partnerService.setPartner(partner);
    setSelectedLang(language);
  };

  const handleCall = async () => {
    if (!partner) return;

    const interpreter = partner as Interpreter;
    if (!interpreter.interpreterLanguage) {
      alert("Please select language.");
      return;
    }

    // Proceed to confirmation page before starting the call
    await navigate("/confirm");
  };

  return (
    <div className="flex flex-col items-center p-6 gap-y-4 justify-center min-h-screen w-full">
        <div className="w-full max-w-3xl border p-6 rounded-3xl shadow-md bg-white flex flex-col items-center overflow-hidden mx-auto">
          {/* Logo */}
          {logo && (
            <div className="mt-6">
              <img
                src={logo}
                alt="logo"
                className="w-[172px] h-[64px] mx-auto"
              />
            </div>
          )}

          {/* Header */}
          <div className="mt-8 mb-6 text-center">
            <h2 className="text-lg font-semibold leading-relaxed">
              Welcome to Samitivej Interpreter Service
              <br />
              Please select your language
            </h2>
          </div>

          {/* Language buttons */}
          <div className="w-full space-y-3">
            {interpreterLanguages.map((lang) => (
              <button
                key={lang.language}
                id={lang.language}
                onClick={() => selectLanguage(lang.language)}
                className={`flex items-center justify-between w-full border rounded-full py-3 px-6 transition-colors 
              ${
                selectedLang === lang.language
                  ? "bg-[#198754] text-white"
                  : "bg-white hover:bg-gray-100"
              }`}
              >
                <img
                  src={lang.flag}
                  alt={lang.language}
                  className="h-[30px] w-auto"
                />
                <span className="font-bold text-lg">{lang.name}</span>
              </button>
            ))}
          </div>

          {/* Call button */}
          <div className="w-full mt-8">
            <button onClick={handleCall} className="interpreter-call-btn">
              Call
            </button>
          </div>

      </div>
    </div>
  );
};

export default InterpreterSelectLanguage;
